import CryptoJS from "crypto-js";

export const loadScript = src =>
  new Promise((resolve, reject) => {
    const s = document.createElement('script');

    s.src = src;
    s.onload = resolve;
    s.onerror = reject;
    document.head.appendChild(s);
  });

export const getContainersInnerHTML = html => {
  return html.match(/<div class="container"[^>]*>([\s\S]*)<\/div>/)[1];
};

export const getBodyInnerHTML = html => {
  return html.match(/<body[^>]*>([\s\S]*)<\/body>/)[1];
};

export const textTransform = () => {
  return `${process.env.REACT_APP_COUNTRY === 'grc' ? 'none' : 'uppercase'}`;
}

export function encryptDataString(data) {
  const key = CryptoJS.enc.Hex.parse(process.env.REACT_APP_ENCRYPTION_KEY);
  const iv = CryptoJS.lib.WordArray.random(16);

  const encrypted = CryptoJS.AES.encrypt(
    data,
    key,
    {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }
  );

  const combined = iv.clone().concat(encrypted.ciphertext);
  return CryptoJS.enc.Base64.stringify(combined).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}